import { render, staticRenderFns } from "./DesignationStatus.vue?vue&type=template&id=2e1289f5&"
import script from "./DesignationStatus.vue?vue&type=script&lang=js&"
export * from "./DesignationStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports